namespace GeniuzPOS.SalePromoCamp {
    export enum PostStatus {
        UnPost = 0,
        Posted = 1
    }
    Serenity.Decorators.registerEnumType(PostStatus, 'GeniuzPOS.SalePromoCamp.PostStatus');
}
